/**
 * Computes club-wide combined Elo from mixed and levels ratings.
 * Uses only disciplines the player has actually played this season.
 *
 * @param {Object} params
 * @param {number|null|undefined} params.mixedElo
 * @param {number|null|undefined} params.levelsElo
 * @param {number|null|undefined} params.mixedGamesPlayed
 * @param {number|null|undefined} params.levelsGamesPlayed
 * @returns {number|null} Combined Elo, or null when player has no rated games
 */
export const computeCombinedLeaderboardElo = ({
  mixedElo,
  levelsElo,
  mixedGamesPlayed = 0,
  levelsGamesPlayed = 0,
}) => {
  const hasMixed = (mixedGamesPlayed ?? 0) > 0 && mixedElo != null;
  const hasLevels = (levelsGamesPlayed ?? 0) > 0 && levelsElo != null;

  if (hasMixed && hasLevels) {
    return Math.round((mixedElo + levelsElo) / 2);
  }
  if (hasMixed) return mixedElo;
  if (hasLevels) return levelsElo;
  return null;
};

/**
 * @param {Object} pcrRow - player_club_elo_ratings row with nested players
 * @returns {number|null}
 */
export const combinedEloFromPcrRow = (pcrRow) =>
  computeCombinedLeaderboardElo({
    mixedElo: pcrRow?.mixed_elo_rating,
    levelsElo: pcrRow?.levels_elo_rating,
    mixedGamesPlayed: pcrRow?.mixed_games_played,
    levelsGamesPlayed: pcrRow?.levels_games_played,
  });
